export const CONFIRM_MODAL_ACTION = "CONFIRM_MODAL_ACTION"
export const CONFIRM_MODAL_ACTION_SUCCESS = "CONFIRM_MODAL_ACTION_SUCCESS"
export const CONFIRM_MODAL_ACTION_ERROR = "CONFIRM_MODAL_ACTION_ERROR"
